import React from 'react';

import { Box, Typography, Button, } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import UserProfileMessage from './UserProfileMessage';
import { time_ago } from '../../../utils/CommonUtils';

const AdminInfo = ({ hideOnMobile, userData,isDeletedAccount=false }) => {
    // const Height = convertHeightInScale(userData.tall);
    const memberSince = userData.createdAt ? time_ago(userData.createdAt) : "NA"
    const userStatus = [
        userData?.currentRelationshipStatus,
        !isDeletedAccount && memberSince ? `Member Since: ${memberSince}` : null
    ].filter(Boolean);
    return (
        <Box sx={{
            backgroundColor: '#FFFFFF', padding: { xs: '16px 0px', sm: '24px 20px' }, borderRadius: { xs: '0', sm: 2, }, display: {
                xs: hideOnMobile ? 'none' : 'block',
                md: 'block'
            }
        }}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                <Box>
                    {/* Name + Age + Verified Badge + Online Chip */}
                    <Box display="flex" alignItems="center" gap={2}>
                        <Typography className="FontIvypresto" fontWeight={600} sx={{ fontSize: { xs: '18px', lg: '28px', xl: '30px' }, color: '#6A513E', }}>{userData?.firstName?.toUpperCase() ?? userData?.userName?.toUpperCase()}, {userData?.age}</Typography>
                        {userData?.isProfileVerified && <Box
                            component="img"
                            src='/assets/images/user-profile/blue-check-icon.svg'
                            alt="blue check icon"
                            sx={{
                                width: { xs: 16, sm: 20, lg: 24 }, // adjust sizes as needed
                                height: 'auto',
                            }}
                        />}
                    </Box>
                    <Box display="flex" alignItems="center" gap={1} sx={{ paddingTop: { xs: '7px', sm: '0' } }}>
                        <img src='/assets/images/user-profile/address-icon.svg' alt='address' class="img-fluid" />
                        <Typography variant="body2" color="#5F6368" sx={{ fontSize: { xs: '12px', sm: '14px', xl: '16px' } }}>
                       {[userData.city, userData.state, userData.country].filter(Boolean).join(", ")}
                        </Typography>                      
                    </Box>

                    {/* Location and Distance */}

                </Box>
                {userData?.isSubscribed && (
                <Box sx={{ background: 'linear-gradient(90deg, rgba(252, 198, 0, 1) 0%, rgba(253, 154, 0, 1) 100%)', padding: { xs: '4px 8px', xl: '8px 14px' }, borderRadius: '8px' }}>
                    <img src='/assets/images/user-profile/crown-iocn.svg' class="img-fluid" alt='crown' />
                </Box>
                )}
            </Box>
            <Box className='d-flex align-items-center flex-wrap MobileJutifyCenter' sx={{ gap: '8px', mt: '15px' }}>
                {userStatus.map((role, index) => (
                    <Box key={index} className="mobileKeyButton" sx={{ backgroundColor: "#D3D3D345", color: "#3C4043", fontSize: { xs: '12px', sm: '12px', xl: '14px' }, fontWeight: 500, padding: { xs: '3px 10px', xl: "6px 14px" }, borderRadius: "8px", display: "inline-block", }}>
                        {role}
                    </Box>
                ))}
            </Box>

            {/* <Box sx={{ mt: { xs: '10px', sm: '15px' } }}>
                <Typography
                    sx={{
                        fontSize: { xs: '12px', sm: '14px', xl: '16px' },
                        color: '#3D3D3D',
                        fontWeight: '400',
                    }}
                >
                    {userData?.myHeading || ""}
                </Typography>
            </Box> */}
            {/* <UserProfileMessage memberData={userData} /> */}
        </Box>
    );
};

export default AdminInfo;
